import { getAppLanguage, type ApiLanguage } from '@/i18n/languages';

export type WorkspaceLanguage = ApiLanguage;

export function getWorkspaceLanguage(i18nLanguage: string): WorkspaceLanguage {
  return getAppLanguage(i18nLanguage).apiValue;
}
